import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withTheme } from 'styled-components';
import { styled } from '../utils/styled';
import { propStyles } from '../utils/propStyles';
import { Theme } from '../models/Theme';

const ReadMoreLessWrapperStyled = styled<any, any>(
    'div',
    'readMoreLessWrapperStyled',
    'readMoreLessWrapper'
)`
    ${propStyles};
`;

ReadMoreLessWrapperStyled.defaultProps = {
    overflow: 'hidden',
    height: '55px',
};

interface ReadMoreLessWrapperProps {
    theme?: Theme;
    isFocused?: boolean;
    getReadMoreLessWrapperReference?: (instance: HTMLElement) => void;
    height?: string;
    overflow?: string;
    tabIndex?: number;
}

@observer
class ReadMoreLessWrapper extends Component<ReadMoreLessWrapperProps> {
    ref: HTMLElement | null | undefined;

    componentDidMount() {
        this.setFocus();
    }

    componentDidUpdate() {
        this.setFocus();
    }

    setFocus() {
        const { isFocused } = this.props;
        if (isFocused && this.ref) {
            this.ref.focus();
        }
    }

    assignReference = (instance: HTMLElement | null) => {
        const { getReadMoreLessWrapperReference } = this.props;
        this.ref = instance;
        if (getReadMoreLessWrapperReference) {
            return getReadMoreLessWrapperReference(instance);
        }
    };

    render() {
        const { theme, children, ...props } = this.props;
        return (
            <ReadMoreLessWrapperStyled
                ref={this.assignReference}
                {...theme.ReadMoreLessWrapper}
                {...props}
            >
                {children}
            </ReadMoreLessWrapperStyled>
        );
    }
}

export default withTheme(ReadMoreLessWrapper);



// WEBPACK FOOTER //
// ./src/Components/ReadMoreLessWrapper.tsx